import { isFieldExpression } from 'automation-ui-formula-editor/formula-editor/grammar/expressionUtils';
// @ts-expect-error untyped module automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser
import { parse as hubLParse } from 'automation-ui-formula-editor/formula-editor/grammar/hubL/hubLParser';
import { StringTemplateStartRule } from 'automation-ui-formula-editor/formula-editor/grammar/constants/StartRules';
const convertTokenPrefixes = (content, fromPrefix, toPrefix) => {
  return content.replace(new RegExp(`{{\\s*${fromPrefix}\\.(\\S+)\\s*}}`, 'g'), (_, property) => `{{ ${toPrefix}.${property} }}`);
};
const convertFunctionTokens = content => {
  return content.replace(/{{\s*personalization_token\(\s*'(\S+)\.(\S+)'.*?\)\s*}}/g, (_, prefix, property) => `{{ ${prefix}.${property} }}`);
};
export const getServiceTokenPrefix = propertyTypeId => `_${propertyTypeId.replace('-', '_')}`;
export const hasToken = content => {
  if (!content) {
    return false;
  }
  try {
    const {
      fields
    } = hubLParse(content, {
      startRule: StringTemplateStartRule
    });
    return fields.length >= 1 && fields.every(field => isFieldExpression(field));
  } catch (_unused) {
    return false;
  }
};
export const convertTokensToEditorFormat = (personalizedContent, {
  propertyTypeId,
  propertyObjectFQN,
  serviceUsesFQNs = false
}) => {
  if (serviceUsesFQNs) {
    return personalizedContent;
  } else {
    return convertTokenPrefixes(personalizedContent, getServiceTokenPrefix(propertyTypeId), propertyObjectFQN);
  }
};
export const convertTokensToServiceFormat = (personalizedContent, {
  propertyTypeId,
  propertyObjectFQN,
  serviceUsesFQNs = false
}) => {
  if (serviceUsesFQNs) {
    return personalizedContent;
  } else {
    let convertedContent = personalizedContent;
    convertedContent = convertFunctionTokens(convertedContent);
    convertedContent = convertTokenPrefixes(convertedContent, propertyObjectFQN, getServiceTokenPrefix(propertyTypeId));
    return convertedContent;
  }
};
export const toSanitizedHTML = ({
  propertyObjectFQN,
  propertyTypeId,
  value,
  removeNewlines = false
}) => {
  if (!value) {
    return null;
  }
  let sanitizedValue = value.replace(/<p>(\s*|&nbsp;)<\/p>/g, '<br/>').replace(/&nbsp;<\/p>$/g, ' </p>');
  if (removeNewlines) {
    sanitizedValue = sanitizedValue.replace(/\n/g, '');
  }
  return convertTokensToServiceFormat(sanitizedValue, {
    propertyTypeId,
    propertyObjectFQN
  });
};
export const fromSanitizedHTML = ({
  propertyObjectFQN,
  propertyTypeId,
  value
}) => {
  if (!value) {
    return undefined;
  }
  const desanitizedValue = value.replace(/<br\/>/g, '<p>&nbsp;</p>');
  return convertTokensToEditorFormat(desanitizedValue, {
    propertyTypeId,
    propertyObjectFQN
  });
};